package dev.mft.website.classes

import org.jetbrains.compose.resources.DrawableResource

data class Technology(
    val resourceId: DrawableResource,
    val contentDescription: String
)
